import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import ReopenJobDescriptionForm from './ReopenJobDescriptionForm';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';

const ReopenJobDescriptionModal = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { closeReopenJobDescriptionModal } = useBiopharmaGroupActions();

  return (
    <StandardModal
      isOpen={biopharmaGroupState?.reopenJobDescriptionModalIsOpen}
      contentLabel={'Reopen Job Description'}
      onRequestClose={() => {
        closeReopenJobDescriptionModal();
      }}
    >
      <PageTitle text={'Reopen Job Description'} />
      <ReopenJobDescriptionForm />
    </StandardModal>
  );
};

export default ReopenJobDescriptionModal;
